"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateNonce = void 0;
const uuid_1 = require("uuid");
const base64_1 = require("./base64");
const generateNonce = () => {
    return (0, base64_1.toBase64Url)(JSON.stringify({
        uuid: (0, uuid_1.v4)(),
        date: new Date().toISOString(),
    }));
};
exports.generateNonce = generateNonce;
